import { render, staticRenderFns } from "./NavBarOpc.vue?vue&type=template&id=cba0895e&scoped=true"
import script from "./NavBarOpc.vue?vue&type=script&lang=js"
export * from "./NavBarOpc.vue?vue&type=script&lang=js"
import style0 from "./NavBarOpc.vue?vue&type=style&index=0&id=cba0895e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba0895e",
  null
  
)

export default component.exports